<div class="plan-card">
  <div class="title-box">
    <div class="plan-title">
      <span class="title">{{ planCard.title }}</span>
      <span *ngIf="planCard.label" class="label">{{ planCard.label }}</span>
    </div>
    <div class="action">
      <ng-container
        *ngIf="planCard.details && planCard.details.selected; else actionButton"
      >
        <button type="button" class="btn" disabled>Current plan</button>
      </ng-container>
      <ng-template #actionButton>
        <button type="button" class="btn" (click)="emitActionChange()">
          <span class="sr-only">{{ planCard.title === 'Monthly Plan' ? 'Select Monthly Plan' : planCard.title === 'Annual Plan' ? 'Select Annual Plan' : planCard.action }}</span>
        <span aria-hidden="true">{{ planCard.action }}</span>
          <span
            aria-hidden="true"
            role="img"
            class="d-flex"
            *ngIf="
              planCard.action == programDisplayData?.planCard?.selectAction ||
              planCard.action == programDisplayData?.planCard?.SNAPAction
            "
          >
            <img
              alt="icon"
              aria-hidden="true"
              [src]="
                planCard.action === programDisplayData?.planCard?.selectAction
                  ? programDisplayData?.planCard?.plusIcon
                  : programDisplayData?.planCard?.moreIcon
              "
            />
          </span>
        </button>
      </ng-template>
    </div>
  </div>
  <div class="divider"></div>
  <div class="content">
    <span class="sr-only">{{planCard.bannerAnouncement}}</span>
    <span class="title" aria-hidden="true" [innerHTML]="planCard.banner"></span>
    <span class="sr-only">{{planCard.subBannerAnouncement}}</span>
    <span [ngClass]="{'changeplan-description': cardType === 'changePlan', 'description': cardType !== 'changePlan'}"
           aria-hidden="true" [innerHTML]="planCard.subBanner"></span>
  </div>

  <ng-container *ngIf="planCard.benefits && planCard.benefits.length">
    <div class="divider"></div>
    <div class="benefits">
      <ng-container *ngFor="let item of planCard.benefits">
        <div
          class="description"
          [ngClass]="{ 'success-color': item.textColor === 'success' }"
        >
          <span aria-hidden="true" role="img">
            <img class="benefitsIcon" alt="icon" aria-hidden="true" src="{{ item.icon }}" />
          </span>
          <span class="trial-content">{{ item.label }}</span>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
